import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-03-29'
        tag='eBay'
        title='Selling Internationally on eBay? Here’s What You Need To Know'
      >
        <p>
          Among the many ways you can increase your sales on eBay, listing items for international sales definitely
          gives you greater visibility among potential buyers. Having a more expansive reach allows you to appear to
          more eBay user accounts and feed. In turn, this increases the opportunity for you to receive inquiries and
          possibly close a sale.
        </p>
        <p>
          While doing so certainly has benefits, you should take note of the policies involving international listings.
          After all, certain items, gadgets, and other paraphernalia may be permissible within your country but are
          restricted to the country where you want to sell them. If you want to know more about these guidelines, we
          have listed some important reminders and tips.
        </p>

        <h3>International Trading Policy</h3>
        <p>
          eBay strongly recommends all its users cross-check if their listings and transactions abide by the
          international trading policy. This means that no one violates any rules about the goods allowed to be imported
          and exported across countries.
        </p>
        <p>
          It is crucial to check your countries’ regulations on international trading so you wouldn’t have to go through
          any inconvenience or, worse, penalties when it turns out that your items and transactions violate the
          policies.
        </p>

        <h3>What to check in selling across eBay global sites</h3>
        <p>
          Different items are not allowed to be sold on specific eBay sites. You should read up on these so you can
          avoid mistakenly putting up a prohibited listing.
        </p>
        <p>For instance, in the United Kingdom and Canada, restricted items include:</p>
        <ul>
          <li>Alcohol.</li>
          <li>Autographed items.</li>
          <li>Electrical and electronic equipment.</li>
          <li>Firearms and accessories.</li>
          <li>Offensive material and propaganda.</li>
          <li>Surveillance equipment.</li>
          <li>Used clothing and cosmetics.</li>
        </ul>
        <p>
          You can check the exhaustive list{' '}
          <a href='https://www.ebay.co.uk/help/policies/prohibited-restricted-items/prohibited-restricted-items?id=4207'>
            here
          </a>{' '}
          and{' '}
          <a href='https://www.ebay.ca/help/policies/prohibited-restricted-items/prohibited-restricted-items?id=4207'>
            here
          </a>
          .
        </p>
        <p>
          You should also discuss the import laws with your customers. This is because there are items that are
          prohibited from being shipped to a country, such as exotic plants, certain food, important books, and
          clothing. Other countries, of course, have different cultures and values and can be the reasons why they don’t
          allow particular items to be imported to them.
        </p>
        <p>
          Naturally, there are also export laws in the country you reside in. For example, specific electronic or
          computer parts are highly regulated in the US. They may be considered “low standards,” but there are still
          policies in handling them.
        </p>
        <p>
          Now, if you have something of high value or in large volumes for international sale, make sure to do
          comprehensive research about the laws within your country and the country you are selling it to. You can also
          read it on <a href='https://www.trade.gov/'>International Trade Administration</a> and the{' '}
          <a href='https://www.cbp.gov/trade/basic-import-export'>US Customers and Border Protection</a> to be
          familiarized with shipping regulations.
        </p>
        <p>
          Take note there is paperwork involved, and so you have to take care of these before letting the buyer purchase
          them and before you ship them to them.
        </p>
        <p>
          If you are uncertain, you can always consult an expert. It is better that you keep asking questions and
          confirming the lawfulness of your actions lest you get caught up in violations.
        </p>
        <p>
          <strong>A pro-tip:</strong> after familiarizing yourself with the trading policies, you can easily cross-post
          your listings to more online marketplaces by using OneShop. The app helps sellers automatically cross-list
          their items to platforms such as Poshmark, Mercari, and soon enough, eBay.
        </p>
        <p>
          From connecting to fellow sellers, providing sales analytics, and setting up bots to help with sales, OneShop
          is a multitasking app you should consider subscribing to. You can check the pricing{' '}
          <a href='https://tools.oneshop.com/pricing'>here</a>.
        </p>

        <h3>Creating buyer requirements</h3>
        <p>
          To help you avoid any problem or additional work in research or negotiations with a potential buyer, take the
          step of setting up buyer requirements.
        </p>
        <p>
          When eBay users come across your listings, they will still see them, but those accounts that fall under your
          restrictions wouldn’t be able to bid or purchase them.{' '}
        </p>

        <h3>Why you would need to restrict buyers</h3>
        <p>
          This is to help you manage who you transact with, primarily if they reside in a country where the items you
          sell are restricted. The similar goes for those countries you don’t want to ship to, most likely because of
          high taxes and shipping costs.
        </p>
        <p>
          Another reason is to avoid eBay users who have a history of multiple canceled orders or those who don’t pay at
          all. Of course, you wouldn’t want the hassle of dealing with these difficult potential customers.
        </p>
        <p>
          Now, there may be instances when you want to restrict buyers from a specific country, but a particular user is
          an online friend. So, you can exempt them from your limitations by clicking and adding them to the “Buyer
          Exemption List” in your account.
        </p>

        <h3>Setting up the requirements</h3>
        <p>
          Head on to the “Buyer Management” page and enter all the restrictions you want to put in place. Make sure to
          select “Apply above settings to active and future listings” so that the limitations will always be applied to
          your listings. Once you are done reviewing the details, simply click “Submit.”
        </p>
        <p>
          You can see your blocked eBay users from the “Buyer Requirements Activity Log,” including the details of the
          activity: who they are and why they were blocked.
        </p>

        <h3>What happens if you earn violations</h3>
        <p>
          When US Customs officials discover your goods violate the International Trading Policy, these items may be
          seized or impounded. In turn, you may be sued or prosecuted. This includes paying fines and other liabilities.
        </p>
        <p>
          Certainly, you don’t want to encounter or experience this, even with the customs officials of the country you
          trade with. Additionally, your buyer may also be affected by this violation, so both of you should properly
          discuss the import and export laws before finalizing any negotiations.
        </p>
        <p>
          To guide you, you can also contact the concerned country’s embassy in the US before doing any transaction.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
